/**
 * Imports the BASE URL from the config.
 */

export default {
    /**
     * GET /manifest/show
     */
    getBookings: function( ){
        return axios.get( '/send-freight/bookings/manifest/show' );
    },

    /**
     * GET /manifest/show
     */
    filterBookings: function( params ){
        return axios.post( '/send-freight/bookings/manifest/filter', params );
    },
}